import { Outlet, ScrollRestoration, useLoaderData } from 'react-router-dom';

import { IPage } from '../models/pages';

import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { NavBar } from '../components/NavBar';

import { useMemo } from 'react';
import { MobileHeader } from '../components/MobileHeader';
import { useScrollToAnchor } from '../hooks/useScrollToAnchor';
import { useMediaQuery } from '../utils/useMediaQuery';

export type AppSection = 'reference' | 'guide' | 'support';

export function Section() {
  useScrollToAnchor();

  const pages = useLoaderData() as {
    pages: Array<IPage>;
    id: AppSection;
  }[];

  const activeSection = window.location.pathname.split('/')[2] as AppSection;

  const activePages = useMemo(
    () => pages.find((x) => x.id === activeSection)?.pages ?? [],
    [activeSection, pages]
  );

  const isLargeScreen = useMediaQuery('(min-width: 1024px)');

  return (
    <div className="flex h-full flex-col text-black dark:bg-inpay-dark-1000 dark:text-white">
      {isLargeScreen ? (
        <Header activeSection={activeSection} pages={activePages} />
      ) : (
        <MobileHeader pages={pages} activeSection={activeSection} />
      )}
      <div className="flex flex-1 flex-row overflow-y-hidden">
        {isLargeScreen &&
        (activeSection === 'guide' || activeSection === 'reference') ? (
          <NavBar pages={activePages} parentSection={activeSection} />
        ) : null}
        <main className="w-full overflow-y-auto" id="main">
          <Outlet />
          <Footer />
          <ScrollRestoration />
        </main>
      </div>
    </div>
  );
}
